import { Modal } from 'antd';
import { TaskLink } from '../../types/TaskLink';
import { BaseButton } from '../UI/BaseButton';
interface DeleteTaskLinkModalProps {
  links: TaskLink[];
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
}

export const DeleteTaskLinkModal = (props: DeleteTaskLinkModalProps) => {
  const { open, onCancel, onOk, links } = props;
  return (
    <Modal
      title={
        <div className="text-brand-grey-dark text-base font-semibold mx-4 mt-3">
          You are about to delete the following link{links.length > 1 ? 's' : ''}:
        </div>
      }
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      centered
      width={640}
      footer={
        <div className="flex justify-end gap-2">
          <BaseButton type="secondary" size="medium" onClick={onCancel}>
            Cancel
          </BaseButton>
          <BaseButton type="primary" size="medium" danger onClick={onOk}>
            {links.length > 1 ? 'Delete Links' : 'Delete Link'}
          </BaseButton>
        </div>
      }
    >
      <div className=" mx-4 mb-10 mt-6 p-3 bg-neutral-200 rounded flex flex-col gap-2 items-center justify-start text-brand-grey-dark text-sm font-medium ">
        {links.map((link) => (
          <div key={link.id} className="w-full truncate overflow-hidden">
            {link.link}
          </div>
        ))}
      </div>
    </Modal>
  );
};
